import React, { useEffect, useState } from 'react';
import { Card, Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { CHUYENDETIENSI_API } from '../../../../utils/apiUrl';
import { Put } from '../../../../utils/httpProvider';
import DocumentInput from '../../../../components/document-input/DocumentInput';
import moment from 'moment';
import { trangThaiChuyenDeValue, objectLoaiChuyenDe } from '../../../../utils/define';

const schema = yup.object().shape({
    loaiChuyenDe: yup.string().required('Vui lòng chọn chuyên đề'),
    tenChuyenDe: yup.string().required('Vui lòng nhập tên chuyên đề')
});

const ChuyenDeTienSiEdit = ({ hoSoId, dataEdit, setViewMode, refreshList }) => {
    const queryClient = useQueryClient();
    const [initialValues, setInitialValues] = useState(null);

    useEffect(() => {
        if (dataEdit) {
            setInitialValues({
                loaiChuyenDe: dataEdit.loaiChuyenDe !== null && dataEdit.loaiChuyenDe !== undefined ? String(dataEdit.loaiChuyenDe) : '',
                tenChuyenDe: dataEdit.tenChuyenDe || '',
                tuNgay: dataEdit.tuNgay ? moment(dataEdit.tuNgay).format('YYYY-MM-DD') : '',
                denNgay: dataEdit.denNgay ? moment(dataEdit.denNgay).format('YYYY-MM-DD') : '',
                fileKy: dataEdit.fileKy || ''
            });
        }
    }, [dataEdit]);

    const editFunc = useMutation((value) => Put(`${CHUYENDETIENSI_API.UPDATE_ITEM}/${dataEdit.id}`, null, value, false));

    const handleUpdate = (values, { setSubmitting }) => {
        const requestData = {
            HoSoNghienCuuSinhId: hoSoId,
            LoaiChuyenDe: values.loaiChuyenDe,
            TenChuyenDe: values.tenChuyenDe,
            TuNgay: values.tuNgay || null,
            DenNgay: values.denNgay || null,
            FileKy: values.fileKy || '',
            TrangThai: dataEdit.trangThai || trangThaiChuyenDeValue.chuaThucHien
        };

        editFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204)) {
                    toast.success('Cập nhật thành công');
                    queryClient.invalidateQueries(['chuyenDeTienSiData', hoSoId]);
                    queryClient.invalidateQueries(['duyetChuyenDeTienSiData', hoSoId]);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    if (!initialValues) return null;

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Cập nhật Chuyên đề tiến sĩ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleUpdate}
                    initialValues={initialValues}
                    enableReinitialize
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Loại chuyên đề <span className="text-danger">*</span></Form.Label>
                                        <Form.Control 
                                            as="select"
                                            name="loaiChuyenDe"
                                            value={values.loaiChuyenDe}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        >
                                            <option value="">Chọn chuyên đề</option>
                                            {objectLoaiChuyenDe.map(t => (
                                                <option key={t.value} value={t.value}>{t.label}</option>
                                            ))}
                                        </Form.Control>
                                        {touched.loaiChuyenDe && !!errors.loaiChuyenDe && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.loaiChuyenDe}</div>}
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Tên chuyên đề <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="tenChuyenDe"
                                            value={values.tenChuyenDe}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.tenChuyenDe && !!errors.tenChuyenDe && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.tenChuyenDe}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Từ ngày</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="tuNgay"
                                            value={values.tuNgay}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Đến ngày</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="denNgay"
                                            value={values.denNgay}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <DocumentInput
                                            labelTitle="File ký ban hành quyết định"
                                            value={values.fileKy}
                                            onChangeProp={(url) => setFieldValue('fileKy', url)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="text-right mt-3">
                                <Button variant="secondary" className="mr-2" onClick={() => setViewMode('list')} disabled={isSubmitting}>
                                    Hủy
                                </Button>
                                <Button variant="primary" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? 'Đang lưu...' : 'Cập nhật'}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default ChuyenDeTienSiEdit;
